export async function postArrive(session: number, landingUrl: string, referer: string) {
    const apiUrl = window.react_data.api_url || 'http://localhost:8000/api/v1/';
    const data = new FormData();
    data.append('session', session.toString());
    if (landingUrl) data.append('landing_url', landingUrl);
    if (referer)    data.append('referer', referer);
    return fetch(apiUrl + 'arrive', { body: data, method: 'post' }).catch(() => {});
}
